<template>
  <div class="text-left mb-15">
    <div class="password-update">
      <el-form
        ref="userpasswordUpdate"
        :model="passwordDetail"
        :rules="passwordChangeRules"
      >
        <el-row>
          <el-col :xs="24" :sm="23" :md="12">
            <el-form-item prop="current">
              <el-input
                :type="curtpasswordInputTypeReg"
                v-model="passwordDetail.current"
                :placeholder="$t('users.label.oldPassword')"
                class="register-input"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="23" :md="12">
            <el-form-item prop="new">
              <el-input
                :type="newpasswordInputTypeReg"
                v-model="passwordDetail.new"
                :placeholder="$t('users.label.newPassword')"
                class="register-input"
              >
                <img
                  slot="suffix"
                  :src="eyeSolidReg"
                  v-if="newpasswordInputTypeReg === 'password'"
                  class="el-input__icon password-icon-class-register"
                  @click="changesPasswordInputType('text', 'new')"
                />
                <img
                  slot="suffix"
                  :src="eyeSlashSolidReg"
                  v-else
                  class="el-input__icon password-icon-class-register"
                  @click="changesPasswordInputType('password', 'new')"
                />
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="text-left mt-15">
          <el-button
            type="primary"
            native-type="submit"
            @click="updateUserPassword"
            class="ctaSubmit"
          >
            {{ $t("users.label.record") }}
          </el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import userApi from "@/api/user";
import eyeSolid from "@/assets/images/icons/password/eye-solid.svg";
import eyeSlashSolid from "@/assets/images/icons/password/eye-slash-solid.svg";
export default {
  props: {
    ctaSubmitText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      passwordDetail: {
        current: null,
        new: null,
      },
      passwordChangeRules: {
        current: [
          {
            required: true,
            message: "Votre Mot de passe actuel est obligatoire",
            trigger: "blur",
          },
        ],
        new: [
          {
            required: true,
            message: "Votre Nouveau mot de passe est obligatoire",
            trigger: "blur",
          },
        ],
      },
      curtpasswordInputTypeReg: "password",
      newpasswordInputTypeReg: "password",
      eyeSolidReg: eyeSolid,
      eyeSlashSolidReg: eyeSlashSolid,
    };
  },
  watch: {
    toggleResetFields() {
      this.resetFields();
    },
  },
  computed: {
    ...mapState("user", ["user"]),
  },
  created() {},
  methods: {
    resetFields() {
      this.$refs.registerForm.resetFields();
    },
    changesPasswordInputType(type, passType) {
      if (passType == "current") {
        this.curtpasswordInputTypeReg = type;
      }
      if (passType == "new") {
        this.newpasswordInputTypeReg = type;
      }
    },
    updateUserPassword(e) {
      e.preventDefault();
      const vm = this;
      this.$refs.userpasswordUpdate.validate().then((valid) => {
        if (valid) {
          const user = localStorage.getItem("user");
          const account = JSON.parse(user);
          if(account && account.id){
            userApi
            .updateUserPassword(account.id, {
              oldPassword: vm.passwordDetail.current,
              newPassword: vm.passwordDetail.new,
            })
            .then(() => {
              this.$emit("emit-password-update");
            })
            .catch((error) => {
              vm.$emit("error", error);
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.delivery-address .el-select {
  border: 1px solid #dcdfe6;
}
.ctaSubmit {
  width: 150px;
  height: 40px;
}
.password-icon-class-register {
  cursor: pointer;
  width: 20px;
  margin-right: 10px;
}
.register-input .el-input__inner {
  margin: 0px !important;
}
</style>
